// extracted by mini-css-extract-plugin
module.exports = {"toolbar":"pluginModal__toolbar___NWAbR","drawingActions":"pluginModal__drawingActions___c-CGb","extraButtonsWrapper":"pluginModal__extraButtonsWrapper___qlgBf"};